export const getSessionValue = (key, defaultValue) => {
    const value = sessionStorage.getItem(key);
    if (!value)
        return defaultValue;
    return JSON.parse(value);
};
export const setSessionValue = (key, value) => {
    if (typeof value === 'undefined' || value === null) {
        return sessionStorage.removeItem(key);
    }
    sessionStorage.setItem(key, JSON.stringify(value));
};
export const getCookie = (name) => {
    if (typeof document === 'undefined')
        return undefined;
    return document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))
        ?.split('=')[1];
};
